/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/mobility': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 0C4.478 0 0 4.477 0 10s4.478 10 10 10 10-4.477 10-10S15.522 0 10 0zM5.657 15.194l-1.051 1.071a.497.497 0 01-.707.007.501.501 0 01-.006-.707l1.051-1.071a.5.5 0 01.713.7zM9.06 11.72l-2.04 2.09a.523.523 0 01-.71 0 .494.494 0 010-.71l2.04-2.08c.19-.19.521-.19.71 0 .09.09.15.21.15.35 0 .13-.05.26-.15.35zm3.722 2.157l-6.659-6.66s7.697-4.775 9.567-2.906c1.868 1.867-2.908 9.566-2.908 9.566z"/><circle pid="1" cx="12" cy="8" r="1.768"/>'
  }
})
